//= require Chart.min
//= require libs/chart.boxplot
//= require libs/chartjs-plugin-annotation.min

import 'src/libs/chartjs-boxplot.js';
import 'chartjs-plugin-annotation';
